import LookerEmbedTab from 'components/LookerEmbedTab'
import React from 'react'

const DASHBOARD_PATH = 'dashboards/302'

const AppInstallsPerLocationPerMonthTab: React.FC = () => (
  <LookerEmbedTab
    path={DASHBOARD_PATH}
    translationKey="looker.urls.dashboards/302"
  />
)

export default AppInstallsPerLocationPerMonthTab
